import { Alert } from 'components'

interface Props {
  isOpen: boolean
}

export const AlertCandidatures = ({ isOpen }: Props) => {
  if (!isOpen) {
    return <></>
  }

  return (
    <Alert
      color="warning"
      isOpen
      className="max-w-7xl mx-auto mt-5 mb-2 shadow-sm"
    >
      Esta vaga não aceita mais candidaturas!
    </Alert>
  )
}
